module.exports = __webpack_public_path__ + "static/media/Fitness-center.ee3f0009.jpg";